export default [
  {
    path: '/locations',
    component: () => import('./Locations.vue'),
    children: [
      {
        path: '/',
        name: 'locationsList',
        component: () => import('./LocationsList.vue')
      },
      {
        path: 'add',
        name: 'addLocation',
        component: () => import('./location-form/LocationForm.vue')
      },
      {
        path: ':id',
        name: 'locationDetails',
        component: () => import('./LocationDetails.vue')
      },
      {
        path: ':id/overrides',
        name: 'locationOverrides',
        component: () => import('./LocationOverrides.vue')
      },
      {
        path: ':id/edit',
        name: 'editLocation',
        component: () => import('./location-form/LocationForm.vue')
      }
    ]
  }
]
